export const getPushToken = () => {
	// ANDROID
	if (navigator.userAgent.toLowerCase().indexOf('android') !== -1) {
		if (typeof window.masterpick != 'undefined') {
			// 모바일 웹 환경 추가
			window.masterpick.nativeGetPushToken();
		}
	}
	// IOS
	if (
		navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ||
		navigator.userAgent.toLowerCase().indexOf('ipad') !== -1
	) {
		window.webkit?.messageHandlers.nativeGetPushToken.postMessage('');
	}
};

export const getPushPermissionYn = () => {
	const agent = navigator.userAgent.toLowerCase();
	// alert(`IOS: ${agent.indexOf('iphone')}`);
	// alert(`ANDROID: ${agent.indexOf('android')}`);
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		if (typeof window.masterpick != 'undefined') {
			window.masterpick.nativeCheckPermissionNotification();
		}
	}
	// IOS
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1)
		window.webkit?.messageHandlers.nativeCheckPermissionNotification.postMessage('');
};

export const requestPermissionNotification = () => {
	const agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1) window.masterpick.nativeRequestPermissionNotification();
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1)
		window.webkit?.messageHandlers.nativeRequestPermissionNotification.postMessage('');
};
